import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { getCancelSubmissionDialogVisible } from 'submission/submissionReducer';
import { Dialog } from 'react-toolbox/lib/dialog';
import theme from 'shared-styles/DialogTheme.css';

import {
  SHOW_CANCEL_SUBMISSION_DIALOG,
  cancelSubmission,
} from 'submission/submissionActions';

const CancelSubmissionDialog = ({ visible, onCancel, onStartOver }) =>
  <Dialog
    actions={[
      { label: 'Yes, start over', onClick: onStartOver },
      { label: 'Cancel', onClick: onCancel },
    ]}
    active={visible}
    onEscKeyDown={onCancel}
    onOverlayClick={onCancel}
    title="Start Over"
    theme={theme}
  >
    <p>Are you sure you'd like to clear this submission and start over?</p>
  </Dialog>;

const mapState = R.pipe(
  R.path(['submission']),
  R.applySpec({
    visible: getCancelSubmissionDialogVisible,
  }),
);

const mapDispatch = dispatch => ({
  onStartOver: () => dispatch(cancelSubmission()),
  onCancel: () =>
    dispatch({ type: SHOW_CANCEL_SUBMISSION_DIALOG, show: false }),
});

export default connect(mapState, mapDispatch)(CancelSubmissionDialog);



// WEBPACK FOOTER //
// ./src/submission/components/CancelSubmissionDialog.js